"use client";

import React from "react";
import Link from "next/link";

const ScheduleExtractionCta: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Ready to Schedule Your Tooth Extraction in Astoria, Queens?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Don&apos;t put off a painful or damaged tooth. Dr. Khaimov will
          assess your situation, go over your options, and make sure
          you&apos;re comfortable every step of the way, from your first visit
          to full recovery.
        </p>
        <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-semibold">
          Call us at{" "}
          <a
            href="tel:+17184004400"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            (718) 400-4400
          </a>{" "}
          to schedule your extraction consultation or{" "}
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            book an appointment
          </Link>{" "}
          online in minutes.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
          <a
            href="tel:+17184004400"
            className="
              uppercase font-semibold text-base tracking-wider text-white
              px-8 py-3
              bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F]
              hover:from-[#ECD05B] hover:via-[#AE7D2F] hover:to-[#ECD05B]
              rounded-lg shadow-lg hover:shadow-inner
              [text-shadow:1px_1px_2px_rgba(0,0,0,0.5)]
              hover:scale-105 transition-all duration-300 ease-in-out
              min-h-[44px] inline-flex items-center justify-center
            "
            aria-label="Call Smile4Me at (718) 400-4400"
          >
            Call (718) 400-4400
          </a>
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="
              uppercase font-semibold text-base tracking-wider text-[#AE7D2F]
              px-8 py-3
              bg-white border-2 border-[#AE7D2F]
              hover:bg-[#AE7D2F] hover:text-white
              rounded-lg shadow-lg
              hover:scale-105 transition-all duration-300 ease-in-out
              min-h-[44px] inline-flex items-center justify-center
            "
            aria-label="Book an appointment online"
          >
            Book Appointment
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ScheduleExtractionCta;
